

































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { DxPopup,DxScrollView,DxLoadPanel } from 'devextreme-vue';
import { DxToolbarItem } from 'devextreme-vue/popup';
import { FeeSheetsService } from '@/service/FeeSheetsService';
 import { alert } from 'devextreme/ui/dialog';
import { QuestelServicesClient } from '@questelservices/common/dist/QuestelServicesClient';
import FileSaver, { saveAs } from 'file-saver';
import {ExportFeeSheetsDto} from '@/models/Fees/ExportFeeSheetsDto'

@Component({
  components: {
    DxPopup,
    DxToolbarItem,
    DxScrollView,
    DxLoadPanel
    
  }
})
export default class emailFeeSheetPreview extends Vue {
    $refs: Vue['$refs'] & {
        
    } = {};

    @Prop({ default: false })
    showDialog!: boolean;

    get showingDialog() {
        return this.showDialog;
    }

    set showingDialog(value) {            
        this.$emit("hiding");
    }

    @Prop()
    previewDisplay!: string;

    @Prop()
    forFeeSheetPreview!: boolean

    @Prop()
    feeSheetIds! : Guid[];

    @Prop()
    feeSheetInstructionId! : Guid;

    get showDisplay() : string {
        return this.previewDisplay;
    }

    get isForFeeSheetPreview() : boolean {
        return this.forFeeSheetPreview;
    }

    get FeeSheetIds() : any {
        return this.feeSheetIds;
    }


    feeSheetService : FeeSheetsService;
    downloadInProgress: boolean = false;
    client: QuestelServicesClient;

    constructor() {
        super();
        this.feeSheetService = new FeeSheetsService('/api/FeeSheets');
        this.client = new QuestelServicesClient(this.$store, '');
    }

    onClose(e:any) {
        this.showingDialog = false;
    }

    async onDownloadFile(e: any) {
        this.downloadInProgress = true;
        if(this.FeeSheetIds) {
            var payload : ExportFeeSheetsDto = {
                FeeSheetIds : this.FeeSheetIds,
                InstructionTemplateId :  this.feeSheetInstructionId,
                TimeZoneOffset: (new Date()).getTimezoneOffset()
            }

            let authorizeDownloadResult = await this.feeSheetService.getExportFeeSheetsPdf(payload)
            .then((res: any) => {
              return res;
            })
            .catch(reason => {
              alert('An error occurred generating the report. Please contact support.', 'Error');
              return undefined;
            })
            .finally(() => {
              this.downloadInProgress = false;
            });

            if (authorizeDownloadResult && authorizeDownloadResult.Url && authorizeDownloadResult.Token) {
                await this.client.download(authorizeDownloadResult.Url, authorizeDownloadResult.Token)
                    .then(result => {
                    let filename = result.headers.get('Filename');

                    result.blob().then((b: any) => {
                        FileSaver.saveAs(b, decodeURIComponent(filename));
                    });
                }).catch(err => {
                    
                });
            }
        }
    }

}
